import { Status, Wrapper } from '@googlemaps/react-wrapper';

import { Icon } from '~src/components/Icon';

import { Loader } from '../Loader';
import { Heading } from '../Typography';
import { Map } from './components/Map';
import { MapOverlay } from './components/MapOverlay';
import { GoogleMapProps } from './types';
import { GOOGLE_API_KEY } from '~src/config';

const BASE_COORDINATES = { lat: 55.6837, lng: 12.5716 };

const renderGoogleMap = (status: Status) => {
  switch (status) {
    case Status.LOADING:
      return <Loader />;
    case Status.FAILURE:
      return (
        <Heading as='div' level={2}>
          <Icon.Info />
          Kunne ikke hente kort
        </Heading>
      );
    case Status.SUCCESS:
    default:
      return <Map />;
  }
};

export const GoogleMap = ({
  center = BASE_COORDINATES,
  zoom = 6,
  disabled,
  setDisabled,
  height = 400,
  markerAdjusted,
  ...rest
}: GoogleMapProps) => (
  <MapOverlay {...{ disabled, setDisabled, height, markerAdjusted }}>
    <Wrapper apiKey={GOOGLE_API_KEY} render={renderGoogleMap}>
      <Map {...{ center, zoom, height, ...rest }} />
    </Wrapper>
  </MapOverlay>
);
